

























































































import Vue from "vue";
import customsSvgIcon from '@/components/Globals/SvgIcon';
import "@/libs/jscolor.js";
import { PickYourOwnColorStoreState } from "@/store/modules/pickYourOwnColor/pickYourOwnColor.t";
import { ISwatch } from "@/store/modules/swatches/swatches.t";
import selectSwatch from '@/mixins/Customizer/SelectSwatch';
const debounce = require("lodash/debounce");

interface JsColorElement extends Element {
  jscolor: any
}

let _uuid = 0
const initialColor = "#ffffff"
const initialMaxHeight = 45.59

// TODO review default swatch properties
const pickYourOwnColorPickerDefaultSwatch = {
  "id": "10900",
  "check_icon_color": "black",
  "factory_name": "",
  "material_type": "svg",
  "status": 1,
  "updated_timestamp": "2022-01-18T23:59:51.000Z",
  "exclusive": false,
  "display_name": {
    "default": ""
  },
  "palette_only": true,
  "material_groups": [
    "unisex-classic-tee_shirt_body"
  ],
  "cq:tags": [
    "customs-products:vans/solids/standard-ugc-solids"
  ],
  "default": false,
  "group": "solids",
  "subgroup": "standard-ugc-solids",
  "swatchId": 10900,
}

export default Vue.extend({
  name: "pickYourOwnColorPicker",
  mixins: [selectSwatch],
  components: {
    customsSvgIcon,
  },
  data() {
    return {
      uuid: -1,
      colorPickerInstance: null as any,
      activeGroup: "",
      value: initialColor,
      previousMaxHeight: initialMaxHeight,
      maxHeight: initialMaxHeight,
      colorValue: initialColor,
    }
  },
  computed: {
    pickYourOwnColor(): PickYourOwnColorStoreState {
      return this.$store.state.pickYourOwnColor
    },
    isOpen(): boolean {
      return this.pickYourOwnColor.isOpen
    },
    assetsPath(): string {
      return this.$store.state.endPoints.customizer.customsAssets
    },
    isMobile(): boolean {
      return this.$store.getters["utils/returnScreenSize"].includes("mobile")
    },
    safeValue(): string | null {
      return this.value && this.value.substr(0, 1) === '#' ? this.value.substr(1) : null
    },
    swatches(): ISwatch[] {
      return this.pickYourOwnColor.swatches
    },
    enableAddSwatch(): boolean {
      return this.pickYourOwnColor.swatches.length < 10
    },
    enableRemoveSwatch(): boolean {
      return this.pickYourOwnColor.swatches.length > 0
    },
    availableSwatches(): any[] {
      return this.$store.state.utils.availableSwatches
    },
  },
  watch: {
    isOpen(newVal) {
      if (newVal && this.$refs.wrapper && !this.colorPickerInstance) {
        this.$nextTick(this.initColorPicker)
      } else if (!newVal && this.colorPickerInstance) {
        this.hideColorPickerInstance()
      }
      if (newVal) {
        this.maxHeight = 1000
      } else {
        this.maxHeight = initialMaxHeight
      }
    },
    ["$refs.colorInput"]() {
      this.$nextTick(this.initColorPicker)
    },
    availableSwatches: {
      immediate: true,
      handler: function () {
        const swatch:ISwatch = this.$store.state.utils.availableSwatches.find((i: ISwatch) => Number(i.id) === 10900);
        const availableSwatches =  this.$store.state.utils.availableSwatches;
        if (!swatch && availableSwatches.length > 0) this.$store.commit("utils/SET_AVAILABLE_SWATCHES", [ ...availableSwatches, pickYourOwnColorPickerDefaultSwatch])
      }
    },
  },
  methods: {
    changeVisibleGroup(groupName: string) {
      this.activeGroup = groupName
      if (groupName === "yourcolors") {
        this.$store.commit("pickYourOwnColor/SET_OPEN_COLOR_PICKER", true)
        if (this.$refs.wrapper && !this.colorPickerInstance) {
          this.$nextTick(this.initColorPicker)
        }
      } else if (groupName !== "yourcolors" && this.colorPickerInstance) {
        this.hideColorPickerInstance()
      }
    },
    initColorPicker(): void {
      const vm: any = this
      const jsColorEl: JsColorElement = vm.$refs.colorInput as JsColorElement
      if (vm.$refs.colorInput && jsColorEl && !vm.colorPickerInstance && vm.isOpen) {
        window.jscolor.installByClassName("jscolor")
        vm.colorPickerInstance = jsColorEl.jscolor
        vm.setColorPickerOptions()
        jsColorEl?.jscolor.show()
      }
    },
    setColorPickerOptions() {
      const vm: any = this
      const { jscolor } = this.$refs.colorInput as JsColorElement
      const { clientWidth, clientHeight } = (this.$refs.colorContainer as Element)
      // adjustment values obtained by trial and error
      let widthAdjustment = 47
      let heightAdjustment = 20
      // Substracting the additional width and
      // height from color calculations to fix its container
      jscolor.width = clientWidth - widthAdjustment
      jscolor.height = clientHeight - heightAdjustment
      jscolor.shadow = false
      jscolor.borderWidth = 0
      jscolor.borderRadius = 0
      jscolor.insetWidth = 1
      jscolor.insetColor = "#ccc"
      jscolor.backgroundColor = "transparent"
      jscolor.value = this.safeValue
      jscolor.pointerBorderWidth = 1
      jscolor.padding = 8
      jscolor.onFineChange = debounce(function () {
        const color = "#" + jscolor.toString(jscolor.rgb)
        vm.colorValue = color
        vm.selectSwatch({
          ...pickYourOwnColorPickerDefaultSwatch,
          color,
          hex: color,
        })
      }, 75)
    },
    onDragHandlebar(event: TouchEvent) {
      // the handlebar only exists in the mobile UI
      if (this.isMobile) {
        // maxDelta adjusts the sensibility, how far the the user must drag the
        // handle in one direction to open or close the color picker
        const maxDelta = 5
        this.previousMaxHeight = this.maxHeight

        const el = document.getElementsByClassName("tab-yourcolors-content")[0]
        const y0 = el.getBoundingClientRect().y
        const y1 = event.targetTouches[0].clientY
        const distFromBaseToHandle = y0 - y1
        const distSinceLastEvent = this.previousMaxHeight - distFromBaseToHandle

        if (Math.abs(distSinceLastEvent) > maxDelta) {
          if (distSinceLastEvent > 0) this.maxHeight = initialMaxHeight
          else this.maxHeight = 1000
        } else {
          this.maxHeight = (distFromBaseToHandle < initialMaxHeight) ? initialMaxHeight : distFromBaseToHandle
        }

        if (this.maxHeight > initialMaxHeight) {
          this.$store.commit("pickYourOwnColor/SET_OPEN_COLOR_PICKER", true)
        } else {
          this.$store.commit("pickYourOwnColor/SET_OPEN_COLOR_PICKER", false)
        }
      }
    },
    onClose(event: Event) {
      this.$store.commit("pickYourOwnColor/SET_OPEN_COLOR_PICKER", false)
      this.$store.commit("pickYourOwnColor/SET_IS_REMOVING", false)
      if (this.colorPickerInstance) {
        this.hideColorPickerInstance()
      }
    },
    hideColorPickerInstance(): void {
      this.colorPickerInstance.hide()
      this.colorPickerInstance = null
    },
    setIsRemoving(): void {
      this.$store.commit("pickYourOwnColor/SET_IS_REMOVING", !this.pickYourOwnColor.isRemoving);
      this.setDataLayer('Remove');
    },
    addSwatch(): void {
      this.$store.commit("pickYourOwnColor/ADD_SWATCH", {
        ...pickYourOwnColorPickerDefaultSwatch,
        color: this.colorValue,
        hex: this.colorValue,
      })
      this.setDataLayer('Add');
      this.$store.dispatch("pickYourOwnColor/SAVE_COLORS", this.swatches.map((color: ISwatch) => color.color))
    },
    loadColors(): void {
      this.$store
        .dispatch("pickYourOwnColor/LOAD_COLORS")
        .then((colors: string[]) => {
          this.$store.commit("pickYourOwnColor/SET_SWATCHES", colors.map((color: string) => {
            return {
              ...pickYourOwnColorPickerDefaultSwatch,
              color,
              hex: color,
            }
          }))
        })
    },
    setDataLayer(eventLabel: string): void {
      this.$customizerDataLayer.logAnalyticsEvent({
        type: this.$customizerDataLayer.types.customizerPickYourOwnColor,
        eventLabel: eventLabel,
        forceEcomDataLayerFormat: true,
      });
    }
  },
  created() {
    this.uuid = _uuid
    _uuid++
    this.$eventBus.$on("changeVisibleGroup", this.changeVisibleGroup)
    this.loadColors()
  },
  mounted() {
    this.$nextTick(this.initColorPicker)
  },
  updated() {
    if (this.$refs.wrapper && !this.colorPickerInstance) this.$nextTick(this.initColorPicker)
  },
  beforeDestroy() {
    this.$eventBus.$off("changeVisibleGroup", this.changeVisibleGroup)

    if (this.colorPickerInstance) {
      this.hideColorPickerInstance()
    }
  },
})

